// extracted by mini-css-extract-plugin
var _1 = "uS59C";
var _2 = "sV2qP";
var _3 = "JFlcK";
export { _1 as "platformSelect", _2 as "select", _3 as "selectAndConfirm" }
